import moment from "moment";
import $http from "../../axios";
import { Notification } from "element-ui";

export async function importIncorporationConsumption({ state, commit }) {
    const formData = new FormData();

    Object.entries(state.formIncorporationConsumption).forEach(
        ([key, value]) => {
            formData.append(key, value);
        }
    );

    commit("setFormIncorporationConsumptionLoading", true);

    await $http
        .post("/api/incorporation-consumption/import", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: response.data.message,
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });

            commit("setFormIncorporationConsumption", {
                account_id: null,
                file: null
            });
            commit("setFormIncorporationConsumptionLoading", false);
        })
        .catch(error => {
            commit("setFormIncorporationConsumptionLoading", false);
        });
}

export async function importIncorporationUsersConsumption({ state, commit }) {
    const formData = new FormData();

    Object.entries(state.formIncorporationUsersConsumption).forEach(
        ([key, value]) => {
            formData.append(key, value);
        }
    );

    commit("setFormIncorporationConsumptionLoading", true);

    await $http
        .post("/api/incorporation-users-consumption/import", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: response.data.message,
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });

            commit("setFormIncorporationUsersConsumption", {
                account_id: null,
                file: null
            });
            commit("setFormIncorporationConsumptionLoading", false);
        })
        .catch(error => {
            commit("setFormIncorporationConsumptionLoading", false);
        });
}

export async function getBankConciliation({ state, commit }) {
    commit("setDataBankConciliationLoading", true);
    await $http
        .get("/api/incorporate-bank-statement/bank-conciliation", {
            params: state.formBankConciliation
        })
        .then(response => {
            commit("setDataBankConciliation", response.data.data);
            commit("setDataBankConciliationLoading", false);
            commit("setBankConciliationTransactionsDetail", false);
            commit(
                "setBankConciliationStatus",
                state.formBankConciliation.state
            );
        })
        .catch(error => {
            commit("setDataBankConciliationLoading", false);
            commit("setBankConciliationTransactionsDetail", false);
            commit("setBankConciliationStatus", null);

            Notification.error({
                title: "Error!",
                message: "Error al traer la informacion.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            console.error(error);
        });
}

export async function getDocumentsByUserId({ state, commit }, contact_id) {
    commit("setDocumentsByUserIdLoading", true);

    const date = !state.reportConsumptionForm.date
        ? moment().format("yyyyMM")
        : state.reportConsumptionForm.date;

    const params = {
        ...state.reportConsumptionForm,
        branchoffice_warehouse_id: localStorage.selected_branchoffice_warehouse,
        date,
        contact_id
    };

    await $http
        .get("/api/incorporation-consumption/documents", { params })
        .then(response => {
            commit("setDocuments", response.data.data);
            commit("setDocumentsByUserIdLoading", false);
        })
        .catch(error => {
            commit("setDocumentsByUserIdLoading", false);

            Notification.error({
                title: "Error!",
                message: "Error al traer la informacion.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            console.error(error);
        });
}

export async function getSubscriberById({ commit }, id) {
    await $http
        .get(`/api/suscriptores/${id}`)
        .then(response => {
            commit("setSubscriber", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function fetchContacts({ commit, state }, filter) {
    const params = {
        pagination: false,
        is_customer: true,
        filter
    };
    await $http
        .get("/api/terceros-lite", { params })
        .then(response => {
            commit("setContacts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function getContact({ commit, state }, id) {
    commit("setDocumentsByUserIdLoading", true);

    await $http
        .get(`/api/incorporation-consumption/contact/${id}`)
        .then(response => {
            commit("setContact", response.data);
            commit("setDocumentsByUserIdLoading", false);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("setDocumentsByUserIdLoading", false);
        });
}



// WEBPACK FOOTER //
// ./src/modules/incorporation-consumption/actions.js